import { unsafeCSS } from "lit";
import { customElement } from "lit/decorators.js";
import { EkoElement } from "@/utilities/element";
import style from "./option-divider.css?inline";

@customElement("eko-option-divider")
class OptionDivider extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-option-divider": OptionDivider;
  }
}

export default OptionDivider;
